function Sales() {
  return null;
}

export default Sales;
